<template>
  <div>
    <!-- <div v-for="(j,index) in item.value.tableAttribute.answer" :key="index">
      <div class="title">
        <p style="margin:10px 0">{{j.title}}</p>
        <div style="background-color: #f9f9f9;padding: 10px;">
          <div v-for="(k,pindex) in j.ques" :key="pindex">
            <div class="title" style="margin:10px 0">{{k.key}}</div>
            <input v-model="k.answer" class="input_bgc" style="width: 100%; outline:none" />
          </div>
        </div>
      </div>
    </div>-->

    <table style="width:100%;" border="0px" cellpadding="5" cellspacing="0">
      <thead>
        <tr>
          <th></th>
          <td
            align="center"
            v-for="(j,index) in item.value.tableAttribute.columns"
            :key="index"
          >{{j}}</td>
        </tr>
      </thead>
      <tbody v-for="(j,_index) in item.value.tableAttribute.answer" :key="_index">
        <tr>
          <th align="left" style="border-bottom:1px solid #efefef;">{{j.title}}</th>
          <td
            align="center"
            style="border-bottom:1px solid #efefef;padding:10px 7px"
            v-for="(k,pindex) in j.ques"
            :key="pindex"
          >
            <input v-model="k.answer" class="input_bgc" style="width: 80%; outline:none" />
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  props: ['item'],

  data() {
    return {
      textValue: '',
      answer: [],
      arr: [],
    }
  },

  created: function () {
    console.log(this.item)
    if (this.item.value.tableAttribute.answer.length == 0) {
      let data = this.item.value.tableAttribute
      let arr = []
      data.lines.forEach((v) => {
        let obj = {}
        obj.title = v
        let ques = []
        data.columns.forEach((j, index) => {
          let obj1 = {}
          obj1.key = j
          obj1.answer = ''
          ques.push(obj1)
        })

        obj.ques = ques
        arr.push(obj)
      })
      console.log(arr)
      this.item.value.tableAttribute.answer = arr
      this.$forceUpdate()
    }
  },
  methods: {
    singleTextChange: function (data) {
      console.log(data)
    },
  },
  watch: {
    item: {
      handler(val) {
        console.log(val)
        if (val.value.tableAttribute.answer.length == 0) {
          let data = this.item.value.tableAttribute
          let arr = []
          data.lines.forEach((v) => {
            let obj = {}
            obj.title = v
            let ques = []
            data.columns.forEach((j, index) => {
              let obj1 = {}
              obj1.key = j
              obj1.answer = ''
              ques.push(obj1)
            })

            obj.ques = ques
            arr.push(obj)
          })
          console.log(arr)
          this.item.value.tableAttribute.answer = arr
          this.$forceUpdate()
        }
      },
      deep: true,
    },
  },
}
</script>
<style>
/* input背景颜色 */
.input_bgc {
  height: 33px;
  border: 1px solid rgb(220, 220, 220);
  border-radius: 5px;
  padding-left: 10px;
  box-sizing: border-box;
  background-color: rgb(246, 248, 252);
}
.border-bottom-1px:after {
  border: none;
}
</style>


